// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"898aeca2","232":"3462eba5","244":"3a9e45ad","400":"4c5f326a","459":"b97717a1","604":"0307ce33","888":"45b16bf5","990":"9057ebe0","998":"3e91cb90"}[chunkId] + ".chunk.js";
};